import React, { createContext, useEffect, useState } from "react";
import chatServices from "services/chatServices";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAcademyBranches } from "hooks/useAcademyBranches";

interface Props {
  children: React.ReactNode;
}

export const AllConversationsContext = createContext<any>(null!);

const AllConversationsProvider: React.FC<Props> = ({ children }) => {
  const [activeConversationId, setActiveConversationId] = useState("");
  const [tempMemberId, setTempMemberId] = useState("");
  const [tempConversationId, setTempConversationId] = useState("");
  const [activeConversationType, setActiveConversationType] =
    useState<any>(null);
  const [auxFolderName, setAuxFolderName] = useState("");
  const [allConversations, setAllConversations] = useState<any>([]);
  const [conversationMembers, setConversationMembers] = useState<any>([]);
  const [unreadMessagesCounter, setUnreadMessagesCounter] = useState<any>(0);
  const [allInterlocutors, setAllInterlocutors] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedChatAcademy, setSelectedChatAcademy] = useState<any>("");
  const {
    academyBranches: chatAcademies,
    ensureAcademyBranchesLoaded,
    refreshAcademyBranches,
  } = useAcademyBranches();

  const [conversation, setConversation] = useState<any>([]);
  const [activeConversationImageUrl, setActiveConversationImageUrl] =
    useState("");
  const [activeConversationName, setActiveConversationName] = useState("");
  const [activeConversationCreatedBy, setActiveConversationCreatedBy] =
    useState("");
  const [activeMemberType, setActiveMemberType] = useState(0);
  const [addNewConversation, toggleAddNewConversation] = useState(false);
  const [addNewGroupConversation, toggleAddNewGroupConversation] =
    useState(false);
  const [onlineProfiles, setOnlineProfiles] = useState<any>([]);
  const location = useLocation();
  useEffect(() => {
    console.log("Wszystkie wiadomosci", conversation);
  }, [conversation]);
  useEffect(() => {

    console.log("selectedChatAcademy xdd", selectedChatAcademy);
  }, [selectedChatAcademy]);






  useEffect(() => {
    ensureAcademyBranchesLoaded();
  }, [ensureAcademyBranchesLoaded]);


  useEffect(() => {
    const handleRouteChange = () => {
      if (location.pathname !== "/chat") {
        setActiveConversationId("");
        setActiveConversationType(null);
        setActiveConversationImageUrl("");
        setActiveConversationName("");
        setActiveConversationCreatedBy("");
        setAllConversations([]);
        setConversation([]);
        setTempMemberId("");
        setConversationMembers([]);
        // setUnreadMessagesCounter(0);
        setAllInterlocutors([]);
        setAuxFolderName("");
        setOnlineProfiles([]);
        setActiveMemberType(1);
        // setTempConversationId("");
        // setSelectedChatAcademy("");
      }
    };

    window.addEventListener("popstate", handleRouteChange);

    handleRouteChange();

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [location]);

  useEffect(() => {
    console.log("activeconversationid", activeConversationId);
  }, [activeConversationId]);

  const permission = useSelector((state: any) => state.permissions.permissions);

  const isAdmin = permission[0]?.Id === -1;
  const hasChatPermission = permission.some((tab: any) => tab.Id === 215);

  const getUnreadMessages = async () => {
    const resp: any = await chatServices.getAllUnreadMessages();
    console.log("unreadmessages>>>>>>>>>>>>>>>>>>", resp);
    setUnreadMessagesCounter(resp);
  };

  useEffect(() => {
    if (isAdmin || hasChatPermission) {
      getUnreadMessages();
    }
  }, [isAdmin, hasChatPermission]);

  const getAllConversations = async (academyId: string) => {
    const resp: any = await chatServices.getAllConversationsWithAcademyId(
      academyId,
      searchQuery || undefined,
    );
    console.log("respASTAT>>", resp);
    setAllConversations(resp.Items);
  };

  useEffect(() => {
    if ((isAdmin || hasChatPermission) && selectedChatAcademy) {
      // @ts-ignore
      getAllConversations(selectedChatAcademy?.value);
    }
  }, [searchQuery, selectedChatAcademy, isAdmin, hasChatPermission]);

  return (
    <AllConversationsContext.Provider
      value={[
        allConversations,
        setAllConversations,
        selectedChatAcademy,
        setSelectedChatAcademy,
        searchQuery,
        setSearchQuery,
        conversation,
        setConversation,
        conversationMembers,
        setConversationMembers,
        activeConversationImageUrl,
        setActiveConversationImageUrl,
        activeConversationName,
        setActiveConversationName,
        onlineProfiles,
        setOnlineProfiles,
        activeConversationId,
        setActiveConversationId,
        activeConversationType,
        setActiveConversationType,
        tempMemberId,
        setTempMemberId,
        unreadMessagesCounter,
        setUnreadMessagesCounter,
        allInterlocutors,
        setAllInterlocutors,
        auxFolderName,
        setAuxFolderName,
        activeMemberType,
        setActiveMemberType,
        tempConversationId,
        setTempConversationId,
        activeConversationCreatedBy,
        setActiveConversationCreatedBy,
        addNewConversation,
        toggleAddNewConversation,
        addNewGroupConversation,
        toggleAddNewGroupConversation,
        chatAcademies,
        refreshAcademyBranches,
      ]}
    >
      {children}
    </AllConversationsContext.Provider>
  );
};
export default AllConversationsProvider;
